export default __webpack_public_path__ + "static/media/mision.24ddf752.png";